import { h } from "@stencil/core";

export const FileUpload = ({ i18nProvider }) => {
    // we use the plain t function instead of the namespace-aware one from the parent component
    const { t } = i18nProvider;

    /**
     * validate max file size: video files up to 50MB, all other files up to 16MB
     * @param file file to validate
     * @returns { isValid: boolean, errorMessage: string | null }
     */
    const validateFile = (file: File): { isValid: boolean; errorMessage: string | null } => {
        const maxSizeInMb = file.type.startsWith("video/") ? 50 : 16;
        const isValid = file.size <= maxSizeInMb * 1024 * 1024;
        // this translation is from the global namespace
        const errorMessage = isValid ? null : t("fileUpload.maxFileSize", { maxSizeInMb });
        return { isValid, errorMessage };
    };

    return (
        <div class="ux-row">
            <div class="ux-col-12">
                <div class="ux-u-margin-bottom-20">
                    {/* max-file-size is set to 9999 because it is checked in validateFile depending on file type */}
                    <ux-file-upload
                        max-file-size="9999"
                        validateFile={validateFile}
                        label={t("mf-service-calls:field.fileUpload.label")}
                        accepted-files="image/*,application/*,text/*,video/mp4,"
                        max-files="4"
                    ></ux-file-upload>
                    <p class="ux-text-tiny">{t("mf-service-calls:field.fileUpload.info")}</p>
                </div>
            </div>
        </div>
    );
};
